// Géocodage léger (Nominatim/OSM, France) — même service que la page Vacances.
export type GeocodedPlace = { lat: number; lon: number; label: string };

export async function geocodeCity(query: string): Promise<GeocodedPlace | null> {
  try {
    const r = await fetch(
      `https://nominatim.openstreetmap.org/search?format=json&countrycodes=fr&limit=1&q=${encodeURIComponent(query)}`,
      { headers: { 'Accept-Language': 'fr' } },
    );
    if (!r.ok) return null;
    const results = (await r.json()) as Array<{ lat: string; lon: string; display_name: string }>;
    const first = results?.[0];
    if (!first) return null;
    const lat = Number.parseFloat(first.lat);
    const lon = Number.parseFloat(first.lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lon)) return null;
    return { lat, lon, label: first.display_name.split(',')[0]?.trim() || query };
  } catch {
    return null;
  }
}
